import { Component, OnInit } from '@angular/core';
import { CalculoSaldoDevedor, CalculoSaldoDevedorRetorno } from 'src/app/model/calculo-saldo-devedor';
import { OperacaoGarantidaService } from '../operacao/operacao-garantida.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { ROLE_GESTOR_CONSULTA, ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { TarefasRemuneracaoService } from '../../tarefas/remuneracao/tarefas-remuneracao.service';

@Component({
  selector: 'app-calculo-saldo-devedor',
  templateUrl: './calculo-saldo-devedor.component.html',
  styleUrl: './calculo-saldo-devedor.component.scss',
  standalone: false,
})
export class CalculoSaldoDevedorComponent implements OnInit {

  public formCalculo: FormGroup;
  public calculoRetorno: CalculoSaldoDevedorRetorno;

  public permissaoEnvio: boolean = false;
  public mostrarResultado: boolean = false;
  public dataUltimaCotacaoSelic: string = '';

  constructor(
    private permissaoService: PermissaoService,
    private operacaoService: OperacaoGarantidaService,
    private tarefasRemuneracaoService: TarefasRemuneracaoService,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp) => {
      this.permissaoEnvio = resp && (resp[ROLE_GESTOR_CONSULTA] || resp[ROLE_GESTOR_ENVIO]);

      console.log(resp[ROLE_GESTOR_CONSULTA])
      console.log(resp[ROLE_GESTOR_ENVIO])
    });

    this.buscarDataUltimaCotacaoSelic();
    this.construirForm();
  }

  calcular() {
    const idOperacaoCredito = this.formCalculo.get('idOperacaoCredito').value;
    const dataCalculo = this.formCalculo.get('dataCalculo').value;

    const dataCalculoFormatada = this.formataData(dataCalculo, 'YYYYMMDD');

    this.operacaoService.calcularSaldoDevedor(idOperacaoCredito, dataCalculoFormatada)
    .subscribe({
      next: (calculoRetorno: CalculoSaldoDevedorRetorno) => {
        console.log(calculoRetorno);
        this.calculoRetorno = calculoRetorno;
        this.mostrarResultado = true;
      },
      error: err => {
        console.error(err);
      }
    });
  }

  buscarDataUltimaCotacaoSelic(): void {
    this.tarefasRemuneracaoService
    .buscarDataUltimaCotacaoSelicCarregada()
    .subscribe({
      next: (data: Date) => {
        this.dataUltimaCotacaoSelic = this.formataData(data, 'DD/MM/YYYY') || '';
      },
      error: (err) => {
        console.error(err);
        this.dataUltimaCotacaoSelic = '';
      }
    });
  }

  construirForm() {
    this.formCalculo = this.formBuilder.group({
      idOperacaoCredito: [null, Validators.required],
      dataCalculo: [null, Validators.required]
    });
  }

  limpar() {
    this.formCalculo.reset();
    this.formCalculo.markAsPristine();
    this.mostrarResultado = false;
  }

  formataData(data: Date, formato: string): string {
    const dataMoment = moment(data);

    if (!data || !dataMoment.isValid())
      return null;

    return dataMoment.format(formato);
  }
 }
